// https://github.com/rebassjs/grid
import styled from "styled-components"
import Box from "components/atoms/Box"

const Flex = styled(Box)({
  display: "flex",
})

export default Flex
